var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('share-frame',{staticClass:"growing-months-asset"},[_c('growing-months-core',{attrs:{"months":_vm.months,"household-name":_vm.householdName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }